import React from 'react';
import useWebContext from '../hooks/useWebContext';
import { MyMImage } from '../ui-elements/MyMImage';

/**
 * FileMappingIcon Component
 * ファイル拡張子に紐づけたアイコン部品
 */
export const FileMappingIcon = ({ screenId, extension, width, height }) => {

  const { controlSettings } = useWebContext(screenId);

  const excelExtensions = ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls'];
  const powerPointExtensions = ['pptx', 'pptm', 'ppt'];
  const pictureExtensions = ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp', 'psd', 'ai'];
  const movieExtensions = ['mp4', 'avi', 'mov', 'webm', 'flv', 'wmv', 'mpeg', 'mpg'];
  const wordExtensions = ['doc', 'docx', 'docm', 'dotm', 'dotx'];
  const pdfExtensions = ['pdf'];
  const inddExtensions = ['indd'];
  const textExtensions = ['txt'];
  const xmlExtensions = ['xml'];
  const zipExtensions = ['zip'];

  let imageControlKey = 'imgNoExtensionImageIcon';
  const lowerExtension = extension?.toLowerCase();
  if (excelExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgExcelIcon';
  } else if (powerPointExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgPowerPointIcon';
  } else if (pictureExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgPictureIcon';
  } else if (movieExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgMovieIcon';
  } else if (wordExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgWordIcon';
  } else if (pdfExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgPdfIcon';
  } else if (inddExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgInddIcon';
  } else if (textExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgTextIcon';
  } else if (xmlExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgXmlIcon';
  } else if (zipExtensions.includes(lowerExtension)) {
    imageControlKey = 'imgZipIcon';
  }
  
  const fileIconPath = controlSettings.ImageList[imageControlKey];

  return (
    <MyMImage
      screenId={screenId}
      filePath={fileIconPath}
      width={width}
      height={height}
    />
  );
};